<template>
  <component :is="component" />
</template>

<script>
import Store from './Store';

export default Store;
</script>

<style lang="scss" scoped>
@import 'Store';
</style>
